import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

import { CustomerSelectorComponent } from "./component";
import { useAdmin, useApi } from "../../../contexts/app/provider";

export const CustomerSelectorContainer = () => {
  const { allCustomers } = useAdmin();
  const { selectedCustomerId, setSelectedCustomerId } = useApi();
  const navigate = useNavigate();
  const selectCustomer = useCallback(
    (customerId: string | null) => {
      if (customerId === selectedCustomerId) return;
      setSelectedCustomerId(customerId);
      navigate("/run-history", { replace: true });
    },
    [navigate, selectedCustomerId, setSelectedCustomerId],
  );

  return (
    <CustomerSelectorComponent
      onSelect={selectCustomer}
      allCustomers={allCustomers || []}
      selectedCustomerId={selectedCustomerId}
    />
  );
};
